import { UserManager, WebStorageStateStore, InMemoryWebStorage } from 'oidc-client-ts'
import { useUserStore } from '@/stores/user'
import { LOGGER } from '@/util/logger'

const storage = new InMemoryWebStorage()
const userManager = new UserManager({
  authority: import.meta.env.VITE_APP_AUTHORITY_ENDPOINT,
  client_id: import.meta.env.VITE_APP_CLIENT_ID,
  application_type: 'PUBLIC',
  scopes_supported: ['openid', 'profile'],
  grant_types_supported: ['authorization_code', 'refresh_token'],
  response_types_supported: ['Code'],
  redirect_uri: import.meta.env.VITE_APP_REDIRECT_URI,
  response_type: 'code',
  scope: 'openid profile',
  automaticSilentRenew: true,
  client_authentication: 'client_secret_post',
  post_logout_redirect_uri: '/logout',
  revokeTokensOnSignout: false,
  userStore: new WebStorageStateStore({ store: storage }),
  stateStore: new WebStorageStateStore({
    store: globalThis.localStorage,
  }),
  metadataSeed: {
    end_session_endpoint: import.meta.env.VITE_APP_END_SESSION_ENDPOINT,
  },
})
export default {
  getUser: () => userManager.getUser(),
  login: () => {
    const originalUrl = globalThis.location.href || ''
    if (!originalUrl.includes('affwebservices') && !originalUrl.includes('code')) {
      localStorage.setItem('originalUrl', originalUrl)
    }
    return userManager.signinRedirect()
  },
  logout: async () => {
    const userStore = useUserStore()
    userStore.setUser(null)
    // userManager.signoutRedirect().. need to remove stuff manually because by default oidc-client will add id_token_hint and ESEC doesn't work with that extra params
    await userManager.revokeTokens()
    await userManager.removeUser()
    await userManager.clearStaleState()
    globalThis.location.assign(userManager.settings.metadataSeed.end_session_endpoint)
  },

  isAuthenticated: async () => {
    let user
    try {
      user = await userManager.signinRedirectCallback()
    } catch (error) {
      LOGGER.logException(error)
    }
    return !!user && !user.expired
  },
}
